import { render, staticRenderFns } from "./WhosTraveling.vue?vue&type=template&id=5a793a36&scoped=true&"
import script from "./WhosTraveling.vue?vue&type=script&lang=js&"
export * from "./WhosTraveling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a793a36",
  null
  
)

export default component.exports